const SequenceQueue = () => {

	const queue = [];
	return {
		create: (sourceArr = []) => {

			sourceArr.forEach((ele) => {

				queue.push({ ShortSku: ele.ShortSku, Id: ele.Id });

			});

		},

		addSkutoQueue: (oldItemsList = [], newItemList = [], isComboSku = false) => {

			const productItem = findAddedItems(oldItemsList, newItemList, isComboSku);
			productItem.forEach((ele) => {

				queue.splice(0, 0, { ShortSku: ele.ShortSku, Id: ele.Id });

			});

		},
		updateDataItemWithPosition: (items, position, dataItemid, shortSku) => {

			items.forEach((item) => {

				if (item.ShortSku == shortSku) {

					if (queue[position].Id === dataItemid) {

						queue[position].Id = item.Id;

					}

				}

			});

		},
		updateAndRemoveItemId: (items = [], position, shortSku) => {

			// Create a mapping of ShortSku to Id from items
			const skuToIdMap = {};
			for (const item of items) {

				skuToIdMap[item.ShortSku] = item.Id;

			}

			// Update Id in queue using the mapping and remove items without a match
			for (let i = queue.length - 1; i >= 0; i--) {

				const item = queue[i];
				if (skuToIdMap[item.ShortSku]) {

					item.Id = skuToIdMap[item.ShortSku];
					delete skuToIdMap[item.ShortSku]; // Remove the entry from the mapping once it's used

				} else if (item.ShortSku == shortSku) {

					queue.splice(i, 1);

				}

			}

		},
		getSequence: () => queue,
		addElement: (item, position) => {

			queue.splice(position, 0, item);

		},

		removeElement: (position) => {

			queue.splice(position, 1);

		},
		removeItemWithSku: (shortSku) => {

			for (let i = 0; i < queue.length; i++) {

				if (queue[i].ShortSku == shortSku) {

					queue.splice(i, 1);

				}

			}

		},
		addRecommendedBulbs: (updatedCartItems) => {

			// insert recommended item in the queue list.

			const difference = updatedCartItems.filter(
				(newItem) => !queue.find((oldItem) => oldItem.ShortSku === newItem.ShortSku && oldItem.Id === newItem.Id)
			);

			if (difference.length > 0) {

				difference.forEach((newElement) => {

					const correspondingItem =						updatedCartItems[
						updatedCartItems.findIndex(
							(item) => item.ShortSku === newElement.ShortSku && item.Id === newElement.Id
						) - 1
					];
					if (correspondingItem) {

						const correspondingIndex = queue.findIndex(
							(item) => item.ShortSku === correspondingItem.ShortSku && item.Id === correspondingItem.Id
						);
						queue.splice(correspondingIndex + 1, 0, newElement);

					}

				});

			}

		}
	};

	function findAddedItems (oldItemsList, newItemList, isComboSku) {

		const keyExtractor = isComboSku ? (item) => `${item.ShortSku}-${item.Id}` : (item) => item.Id;

		const addedItems = [];

		// Create a set of keys for faster lookup
		const oldItemKeys = new Set(oldItemsList.map(keyExtractor));

		// Iterate through newItemList and check if each item is in oldItemKeys
		for (const newItem of newItemList) {

			const newItemKey = keyExtractor(newItem);
			if (!oldItemKeys.has(newItemKey)) {

				addedItems.push(newItem);

			}

		}

		return addedItems;

	}

};

export default SequenceQueue;
